import {GET_ALL_DEPARTMENTS, GET_ALL_EMPLOYEES, GET_ALL_REGIONS, GET_COMPANY_DATA} from "./companyActionTypes";
import axios from '../../axiosApi';
import {CONFIG} from "../../constants/backendUrl";

export const getCompanyDataSuccess = (value) => ({type: GET_COMPANY_DATA, value});
export const getAllDepartments = (value) => ({type: GET_ALL_DEPARTMENTS, value});
export const getAllEmployees = (value) => ({type: GET_ALL_EMPLOYEES, value});
export const getAllRegions = (value) => ({type: GET_ALL_REGIONS, value});

export const getCompanyData = (hash) => {
    return async dispatch => {
        try {
            const response = await axios.get(`/${CONFIG['historyApi']}/header/method/info?hash=${hash}`);
            dispatch(getCompanyDataSuccess(response.data));
        } catch (err) {
            console.log(err);
        }
    }
}
